import React, { Component } from 'react';
import "./RatingCard.css";
import RatingCapsuleModal from "../ProgressCapsules/RatingCapsuleModal";
import Modal from "react-responsive-modal";
import { withFirebase } from '../../Firebase';
import { withRouter } from 'react-router-dom';
import Rater from 'react-rater'
import 'react-rater/lib/react-rater.css'
import DefaultPicture from '../../../assets/example-productivity.jpg';
import LikeComponent from '../../Card/LikeComponent';

class RatingCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            capsule: this.props.capsule,
            numberIdeas: "",
            numberPolls: "",
            ratingOpen: true,
            ratingModalOpen: false,
            ratingCapsule: 0,
            firstRate: 0,
            status: this.props.card,
            ratingList: [],
            uid: "",
            currentUser: this.props.currentUser,
            user: { firstname: "", lastname: "" },
            activator: { firstname: "", lastname: "" }
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.capsule !== this.state.capsule) {
            this.setState({ capsule: nextProps.capsule })
            this.updateCapsuleInfo(nextProps.capsule);
        }
    }

    componentDidMount() {
        this.updateCapsuleInfo(this.props.capsule);
    }

    updateCapsuleInfo(capsule) {
        let uid;
        if (this.props.firebase.auth.currentUser) {
            uid = this.props.firebase.auth.currentUser.uid
            this.setState({ uid: uid })
        }
        this.props.firebase.db
            .collection("capsules")
            .doc(capsule.id)
            .collection("ideas")
            .get()
            .then(querysnapshot => {
                let ideas = querysnapshot.docs.map(doc => {
                    let data = doc.data()
                    return {
                        id: doc.id,
                        ...data
                    }
                });
                this.setState({ numberIdeas: ideas.length })
            })

        this.props.firebase.db
            .collection("capsules")
            .doc(capsule.id)
            .collection("polls")
            .get()
            .then(querysnapshot => {
                let polls = querysnapshot.docs.map(doc => {
                    let data = doc.data()
                    return {
                        id: doc.id,
                        ...data
                    }
                });
                this.setState({ numberPolls: polls.length })
            })
        let ratingList = capsule.ratingList;
        this.setState({ ratingList: ratingList })

        this.ratingFunction(ratingList);
        let isRate = ratingList.find(rating => uid === rating.user)
        if (isRate) {
            this.setState({ ratingOpen: false });
        }

        this.props.firebase.db
            .collection("users")
            .doc(capsule.creator)
            .get().then((doc) => {

                this.setState({ user: doc.data() })
            })

        if (capsule.activatorId) {
            this.props.firebase.db
                .collection("users")
                .doc(capsule.activatorId)
                .get().then((doc) => {
                    this.setState({ activator: doc.data() })
                })
        }
    }

    openRating = () => {
        this.setState({
            ratingModalOpen: true
        })
    }

    closeRating = () => {
        this.setState({
            ratingModalOpen: false,
        })
    }

    onRatingCaps = (rating) => {
        const { uid, ratingList } = this.state
        this.setState({ firstRate: rating });
        let isRate = ratingList.find(rating => uid === rating.user)
        if (isRate === undefined) {
            this.openRating()
        }
    }

    addRating = (rating, commentaire) => {
        const { uid, ratingList, capsule, currentUser } = this.state
        let list = ratingList;
        const name = currentUser.firstname + ' ' + currentUser.lastname;
        const image = currentUser.image_url_profile ? currentUser.image_url_profile : '';
        const position = currentUser.position ? currentUser.position : '';
        list.push({ rate: rating, user: uid, commentaire: commentaire, username: name, position: position, image: image })
        this.ratingFunction(list)
        this.setState({ ratingOpen: false });
        this.props.firebase.db
            .collection("capsules")
            .doc(capsule.id)
            .set({ ratingList: list }, { merge: true })
            .catch((error) => console.error(error))
    }

    ratingFunction = (ratingList) => {
        let nbrRate = ratingList.length;
        let total = 0;
        let finalRate = 0;
        ratingList.forEach((rating) => {
            total += rating.rate;
        })
        finalRate = total / nbrRate;
        this.setState({ ratingCapsule: Math.round(finalRate) })
    }

    openCapsule = () => {
        const { capsule } = this.state
        this.props.history.push(`/capsule/${capsule.id}`);
    }

    render() {
        const { capsule, numberIdeas, numberPolls, ratingCapsule, status, ratingOpen, user, activator } = this.state;
        return (
            <div>
                <div onClick={this.onOpen} className="inactive-card card cursor-pointer">
                    <img onClick={this.openCapsule} className="card-img-top img-cropper-rating" src={capsule.image_url_capsule || DefaultPicture} alt="Card" onError={this.props.firebase.profileImgError} />
                    <div className="reactive-card-header">
                        <div className="reactive-card-title">{capsule.title}</div>
                    </div>

                    <img hidden={this.props.inAccount} className="rating-card-bottom-background" src={require('../../../assets/cards/card_white_shape.svg')} alt="Bottom" />
                    <img hidden={!this.props.inAccount} className="rating-card-bottom-background" src={require('../../../assets/cards/card_white_no_shape.svg')} alt="Bottom" />
                    <div className="reactive-card-body progress-body">
                        <div className="reactive-card-like-container position-logo">
                            <img alt="icon" className="mb-2" src={require('../../../assets/cards/icon_defis_realises.svg')} />
                        </div>
                        <p className="activated-text-blue" hidden={!activator}> Réalisée par {activator.firstname} {activator.lastname}</p>
                        <p className="activated-text-blue"> Créée par {user.firstname} {user.lastname}</p>
                        <div className="d-flex">
                            <div className="width-ideas-polls">
                                <p className="reactive-card-other-text">{numberPolls} {(numberPolls === 1) ? 'sondage' : 'sondages'}</p>
                                <p className="reactive-card-other-text">{numberIdeas} {(numberIdeas === 1) ? 'idée' : 'idées'}</p>
                            </div>
                            <div hidden={status === 'realise'}>
                                <Rater rating={ratingCapsule} total={5} interactive={false} />
                                <h1 className="rate-text-card">{ratingCapsule}/5 ({capsule.ratingList.length} votes)</h1>
                            </div>
                            <div hidden={status !== 'realise'}>
                                <Rater onRate={({ rating }) => { this.onRatingCaps(rating) }} rating={ratingCapsule} total={5} interactive={ratingOpen} />
                                <h1 className="rate-text-card">{ratingCapsule}/5 ({capsule.ratingList.length} votes)</h1>
                            </div>
                        </div>
                        <div className="finished-card-footer">
                            <div className="size-tag-container">
                                <div hidden={capsule.tags.length !== 0} className="reactive-card-tag">#no tags</div>
                                {capsule.tags.slice(0, 2).map((tag, index) => <div key={index} className="reactive-card-tag">#{tag}</div>)}
                            </div>
                            <div hidden={this.props.inAccount}>
                                <LikeComponent
                                    idcapsule={capsule.id}
                                    card={"basic"}
                                />
                            </div>
                            <div className="like-container" hidden={!this.props.inAccount}>
                                <span className="mr-2">{capsule.nbLikes}</span>
                                <img className="padding-image" src={require('../../../assets/cards/icon_card_like.svg')} alt="Like" />
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    open={this.state.ratingModalOpen}
                    onClose={this.closeRating}
                    center
                    showCloseIcon={true}
                    styles={(window.innerWidth > 768) ? styles_desktop : styles_mobile}
                >
                    <RatingCapsuleModal
                        onClose={this.closeRating}
                        addRating={this.addRating}
                        firstRate={this.state.firstRate}
                    />
                </Modal>
            </div>
        )
    }
}

const styles_desktop = {
    overlay: {
        display: "block",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 9999,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.79)",
        overflow: "auto",
    },
    modal: {
        boxShadow: 'none',
        borderRadius: '4px',
        minHeight: "355px",
        maxWidth: "376px",
        top: "10%",
        padding: "0px",
    }
};

const styles_mobile = {
    overlay: {
        display: "block",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 9999,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.79)",
        overflow: "auto",
        padding: "0px",
    },
    modal: {
        boxShadow: 'none',
        minHeight: "100%",
        width: "100%",
        padding: "0px",
    }
};

const RatingCardBase = withRouter(withFirebase(RatingCard));

export default RatingCardBase;